// Getters (GET*)
export const SETTINGS_GET_VIEW_MODE = 'SETTINGS_GET_VIEW_MODE';

// Mutations (SET*, ADD*, REMOVE*)
// [CONTEXT]_[ACTION]_[PROPERTY]
export const SETTINGS_SET_VIEW_MODE = 'SETTINGS_SET_VIEW_MODE';

// Actions (FETCH*, CREATE*, UPDATE*, DELETE*)
// [CONTEXT]_[ACTION]_[PROPERTY]_[STATUS]
export const SETTINGS_TOGGLE_VIEW_MODE = 'SETTINGS_TOGGLE_VIEW_MODE';
